import { Tick, BrevoInstallImg } from "../../../../../assets";
import { MdMenuBook } from "react-icons/md";
import { BrevoFeatureObj } from "../constants";

const IntegrationBenefits = () => {
  return (
    <section className="max-w-xl">
      <img
        src={BrevoInstallImg}
        alt="Brevo Installation Guide"
        className="my-4"
      />
      <p className="text-sm text-gray-500 my-2.5">
        Keep your subscribers in one place. This integration sends new
        subscribers from CausalFunnel to Brevo (formerly SendInBlue).
      </p>
      <div>
        <h3 className="text-xl font-semibold py-3 border-bottom my-3">
          Integration benefits
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-3">
          {BrevoFeatureObj.map((item, index) => (
            <FeatureItem {...item} key={index} />
          ))}
        </div>
      </div>
      <a
        href="https://www.causalfunnel.com/blog"
        target="_blank"
        rel="noreferrer noopener"
        className="text-indigo-600 hover:underline flex items-center gap-1.5"
      >
        <MdMenuBook className="text-2xl" />
        <p>How to install Brevo?</p>
      </a>
    </section>
  );
};

export default IntegrationBenefits;

const FeatureItem = ({ title, desc }) => {
  return (
    <div className="flex gap-2">
      <div className="">
        <Tick className=" text-green-600" />
      </div>
      <div>
        <h3 className="font-bold text-[14px]">{title}</h3>
        <p className="text-gray-500 text-[14px]">{desc}</p>
      </div>
    </div>
  );
};
